var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "text-center",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('title-rounded', {
    attrs: {
      "title": "당첨 상품"
    }
  }, [_c('v-sheet', {
    staticClass: "text-center brown--text",
    attrs: {
      "max-width": "1100"
    }
  }, [_c('v-row', {
    staticClass: "ma-lg-n24px",
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.reward, function (item) {
    return _c('v-col', {
      key: item.title,
      staticClass: "pa-lg-24px",
      attrs: {
        "cols": "6",
        "md": "auto",
        "data-aos": "fade-up",
        "data-aos-duration": "700",
        "data-aos-delay": item.aosDelay
      }
    }, [_c('div', {
      staticClass: "hunt-reward word-keep-all"
    }, [_c('v-img', {
      staticClass: "d-none d-md-block mx-auto mb-10px",
      attrs: {
        "src": item.image,
        "max-width": "100%",
        "width": item.imageWidth,
        "eager": ""
      }
    }), _c('v-img', {
      staticClass: "d-md-none mx-auto mb-10px",
      attrs: {
        "src": item.imageMo,
        "width": "100%",
        "max-width": "166",
        "eager": ""
      }
    }), _c('h5', {
      staticClass: "font-size-16 font-size-md-32"
    }, [_vm._v(" " + _vm._s(item.title)), item.count ? _c('span', {
      staticClass: "font-weight-regular"
    }, [_vm._v(" (" + _vm._s(item.count) + "명)")]) : _vm._e()]), item.detail ? _c('p', {
      staticClass: "font-size-14 font-size-md-28 mt-10px"
    }, [_vm._v(" " + _vm._s(item.detail) + " ")]) : _vm._e()], 1)]);
  }), 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }